const getters = {
  shareUrl: state => state.data.shareUrl,
  fingerId: state => state.data.fingerId,
  timestamp: state => state.data.timestamp,
  answerQuestionScore: state => state.data.answerQuestionScore,
  answerNickName: state => state.data.answerNickName,
  userFlagList: state => state.data.userFlagList,
  flagSignature: state => state.data.flagSignature,
  aiShareCookbookId: state => state.data.aiShareCookbookId,
  aiGenerateNickName: state => state.data.aiGenerateNickName
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js